import { useCallback } from 'react';
import qs from 'qs';
import { useNavigate } from 'react-router-dom';

import { parseQuery } from 'src/shared/utils';

import { useQuery } from './useQuery';

/**
 * Provides a callback to update the query params of the current navigation location
 * @returns memorized callback to update query params
 */
export const useNavigateByQueryParams = (): ((params: Record<string, any>) => void) => {
  const navigate = useNavigate();
  const query = useQuery();

  const navigateByQueryParams = useCallback(
    (params: Record<string, any>) => {
      const q = parseQuery<Record<string, any>>(query?.toString() ?? '');
      const search = qs.stringify({ ...q, ...params }, { arrayFormat: 'brackets' });

      // Do NOT pass pathname since we just need to append the query params
      navigate({ search: `?${search}` }, { replace: true });
    },
    [query, navigate],
  );

  return navigateByQueryParams;
};
